// Prices from the API remain untouched: these helpers are for display only.
export function taxMultiplier(price = {}) {
  const multiplier = Number(price.taxMultiplier);
  return Number.isFinite(multiplier) && multiplier > 1 ? multiplier : 1;
}

export function displayAmount(amount, price = {}, includeGst = true, noTaxAmount = null) {
  if (amount === null || amount === undefined || !Number.isFinite(Number(amount))) return amount;
  if (includeGst || taxMultiplier(price) === 1) return Number(amount);
  if (noTaxAmount !== null && noTaxAmount !== undefined) return Number(noTaxAmount);
  return Math.round((Number(amount) / taxMultiplier(price) + Number.EPSILON) * 100) / 100;
}

export function serviceDisplayPrice(price, includeGst) {
  if (includeGst || taxMultiplier(price) === 1) return price;
  const result = { ...price };
  const fields = [
    ['productPrice', 'productPriceNoTax'],
    ['discountedProductPrice', null],
    ['renewalPrice', 'renewalPriceNoTax'],
  ];
  fields.forEach(([field, netField]) => {
    result[field] = displayAmount(price[field], price, false, netField ? price[netField] : null);
    if (Number(price.termMonth) > 0 && result[field] !== null && result[field] !== undefined) {
      result[`${field}Monthly`] = result[field] / Number(price.termMonth);
    }
  });
  return result;
}

export default {
  computed: {
    includeGst: {
      get() { return this.$store.state.registrationPricesIncludeGst !== false; },
      set(value) { this.$store.commit('setRegistrationPricesIncludeGst', value); },
    },
    showPricesBeforeGst: {
      get() { return !this.includeGst; },
      set(value) { this.includeGst = !value; },
    },
    registrationTaxMultiplier() {
      const products = Object.values(this.defaultProducts || {}).flat();
      const serviceTerms = products.flatMap((product) => Object.values(product.currencies || {}));
      const domainTerms = Object.values(this.tldPriceList || {})
        .flatMap((tld) => Object.values(tld.terms || {}));
      return Math.max(1, ...serviceTerms.concat(domainTerms).map(taxMultiplier));
    },
    gstApplicable() { return this.registrationTaxMultiplier > 1; },
  },
};
